<template>
  <td @click.stop="onSelectItem(item)" class="t_Edit_caption_3 ftd" :class="[item.class1=='角' ? 'jal' : 'lan']" style="width:20%;height:75px;">
    <span id="n_1503_34">{{item.class3}}<font class="playn" v-if="item.class1=='角'">{{item.class1}}</font></span>
    &nbsp;&nbsp;&nbsp;<span id="r_1">{{item.odds}}</span>
    <br>
    <span class="fspan"></span>
    <input type="text" size="6" class="inp1" v-model="value" :class="{active: selected}" ref="input" maxlength="7" :disabled="item.status >= 2">
  </td>
</template>

<script>
 import {mapState, mapActions} from "vuex";
  import ObjectPath from "object-path";
  import Vue from "../../../utils/bus";

  /***
   * name：g_input_selected_item 不可变
   * 通过 g_input_selected_item 逐级向下查找组件进行数据操作
   */
  export default {
    name: "selected_item",
    props: {
      // 允许选中条件，默认允许选中
      selectRule: {
        type: Function,
        default() {
          return true;
        }
      },
      chip: String,
      type: {
        type: Number,
        default: 1
        // 1 => 文字 + 比率 + 选择框
        // 2 => 数字1 || 文字 + 比率 + 选择框
        // 3 => 数字2 || 文字 + 比率 + 选择框
        // 4 =>               比率  + 选择框
        // 5 => 数字2          + 选择框
      },
      item: {
        type: Object,
        default() {
          return {
            label: "大",
            rate: 1.998,
            selected: false
          };
        }
      },
      isSelectAll: Boolean,
      isWatch: {
        type: Boolean,
        default() {
          return true;
        }
      }
    },
    computed: {
      ...mapState({
        curTab: state => state.home_PK10.curTab,
        headTabs: state => state.home.headTabs,
        tabs: state => state.home_PK10.tabs,
        odds: state => state.home_PK10.odds,
        lottery: state => state.home_PK10.lottery,
        order_history: state => state.home_PK10.order_history,
        longQueue: state => state.home.longQueue,
        statistics: state => state.home.statistics
      })
    },
    watch: {
      item: {
        immediate: true,
        deep: true,
        handler() {
          const {id} = this.item;
          const values = this.$store.state.table.inputValues;
          const value =
            ObjectPath.get(values, `${id}`) || this.item.status === 3
              ? "封盘中"
              : "";
          this.value = this.item.status === 3 ? "" : this.value;
          this.selected = this.item.status === 3 ? false : this.selected;
          this.saveInputValie({value: {[id]: value}});
        }
      },
      'item.rate':function(val,oldval){
        this.item.ischange=true
      },//键路
      value: {
        handler(e) {
          if (e) {
            const {id} = this.item;
            this.saveInputValie({value: {[id]: e}});
            this.selected = true;
          }
        }
      },
      isSelectAll(data) {
        if (this.isWatch) {
          if (data && Number.isInteger(parseInt(this.item.label))) {
            this.selected = true;
            this.value = this.$store.state.inputnum;
          } else {
            this.selected = false;
            this.value = "";
          }
        }else{//快乐十分
          if ( ! data && Number.isInteger(parseInt(this.item.label))) {
            //this.selected = true;
            this.value = this.$store.state.inputnum;
          } else {
            //this.selected = false;
            this.value = "";
          }
        }
      }
    },
    data() {
      return {
        selected: false,
        value: ""
      };
    },
    computed: {
      name() {
        // 为5不可选中
        return this.type === 5
          ? "g_input_selected_item_type_2"
          : "g_input_selected_item";
      }
    },
    methods: {
      ...mapActions("table", {
        saveInputValie: "saveInputValie"
      }),
      showLabel(label) {
        if (this.type === 1) {
        } else {
          if (this.checkNumber(label)) label = "";
        }
        return label;
      },
      onSelectItem(item) {
        if (item.status >= 2) return;
        if (!this.selectRule(this.type, !this.selected)) return;
        this.selected = !this.selected;
        if (
          this.name === "g_input_selected_item" ||
          this.name === "g_input_selected_item_type_2"
        ) {
          this.value = this.selected ? this.chip : "";
        }
        this.$refs.input && this.$refs.input.focus();
	if(this.selected)
	{
	    this.value=this.$store.state.inputnum;	
	}
      },
      checkNumber(str) {
        const n = Number(str);
        return typeof n === "number" && n.toString() !== "NaN";
      }
    },
    created() {
      if (this.isSelectAll && Number.isInteger(parseInt(this.item.label))) {
        this.selected = true;
      }
    }
  };
</script>

<style scoped lang="stylus">
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    background: transparent;
}
.ftable {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    color: white;
}
tr {
    font-size: 14px;
}
.Conter_list {
    height: 28px!important;
}
.t_Edit_caption_3 {
    width: 52px;
    height: 29px;
    line-height: 26px;
    text-align: center;
    background: #fdf8f2;
    vertical-align: middle;
}
.ftd {
    border: 2px #b5b6b6 solid;
}
.jal {
    background-color: #333301;
}
.lan {
    background-color: #7D7D00;
}
.playn {
    color: red;
    font-size: 12pt;
}
span[id^=r] {
    color: rgb(68, 30, 11);
    text-shadow: -1px -1px 1px #ffffff, 1px 1px 1px #ffffff, -1px 1px 1px #ffffff, 1px -1px 1px #ffffff;
}
.dan {
    background-color: #979700;
    border: 1px #7D7D00 solid;
}
.ftable span {
    color: white;
}
span[id^=r] {
    color: rgb(68, 30, 11);
    text-shadow: -1px -1px 1px #ffffff, 1px 1px 1px #ffffff, -1px 1px 1px #ffffff, 1px -1px 1px #ffffff;
}
.fan span {
    color: rgb(68, 30, 11);
}
span[id*=_rat], span[id*=r_], span[id*=rt_], td[id*=r_], td[id*=rt_] {
    font-weight: bold;
}
.Man_Conter {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
}
.ax {
    margin-top: -1px;
}
.Man_Conter td, th {
    border: 1px #E9BA84 solid;
    line-height: 30px;
}
.odds_a {
    color: red;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    cursor: pointer;
}
td[id*=_num], span[id*=n_], span[id*=nt_], td[id*=n_], td[id*=nt_], div[id*=n_], div[id*=nt_], span[class=sGameStatusItem] {
    font-weight: bold;
}
.inp1{
  border: 1px solid #bfbfbf;
  display: inline-block;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/c_game-switch/switch-item/g_switch-item6.vue